import type { FC, ReactNode } from 'react'

import { ArrowLeft, Quote } from 'lucide-react'
import { Reveal } from '@/components/generals/reveal'

const QuoteSection: FC = (): ReactNode => {
    return (
        <section aria-labelledby='quote-title' className='relative isolate overflow-hidden py-24 sm:py-32'>
            <div aria-hidden='true' className='pointer-events-none absolute inset-0 -z-10 bg-[radial-gradient(ellipse_60%_70%_at_50%_100%,oklch(0.29_0.1_22/0.55),transparent_70%)]' />
            <div aria-hidden='true' className='curtain-fabric pointer-events-none absolute inset-x-0 top-0 -z-10 h-24 opacity-40 [mask-image:linear-gradient(to_bottom,black,transparent)]' />

            <Reveal className='mx-auto max-w-4xl px-5 text-center sm:px-8'>
                <h2 id='quote-title' className='sr-only'>
                    כל העולם במה
                </h2>

                <figure>
                    <Quote aria-hidden='true' className='mx-auto size-10 text-primary/70' />

                    <blockquote className='mt-6 font-heading text-3xl font-medium leading-snug text-balance sm:text-5xl sm:leading-tight'>
                        <p>
                            העולם כולו במה, וכל הגברים והנשים אינם אלא שחקנים.
                        </p>
                    </blockquote>

                    <figcaption className='mt-6 text-sm text-muted-foreground'>
                        ויליאם שייקספיר, ״כטוב בעיניכם״
                    </figcaption>
                </figure>

                <p className='mx-auto mt-10 max-w-lg text-base leading-relaxed text-muted-foreground'>
                    התפקיד הראשון של הילד או הילדה שלכם מחכה להם כאן.
                </p>

                <a
                    href='#trial'
                    className='mt-6 inline-flex min-h-12 items-center gap-2 rounded-full bg-primary px-7 text-base font-semibold text-primary-foreground shadow-[0_12px_32px_-12px_oklch(0.8_0.12_80/0.7)] transition-all duration-300 hover:-translate-y-0.5 hover:brightness-110 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background'
                >
                    הרשמה לשיעור ניסיון
                    <ArrowLeft aria-hidden='true' className='size-4' />
                </a>
            </Reveal>
        </section>
    )
}

export default QuoteSection
